<template>
  <div class="product-credit-modal">
    <ProductServiceText :disabled="product?.isPair && !isPairSelected" @click="isOpen = true">
      <svg><use xlink:href="#svg-graph"></use></svg>
      <DefLink>
        {{ title }}
      </DefLink>
    </ProductServiceText>

    <DefSlideModal :active="isOpen" @close="isOpen = false">
      <template #title>
        {{ title }}
      </template>
      <div v-for="credit in result.items">
        <ProductCredit :result="credit" />
      </div>
    </DefSlideModal>
  </div>
</template>

<script>
import ProductServiceText from '@components/Product/ProductServiceText.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import DefSlideModal from '@components/Def/DefSlideModal/DefSlideModal.vue';
import ProductCredit from '@components/Product/ProductCredit/ProductCredit.vue';
import { mapState } from 'vuex';

export default {
  name: 'ProductCreditModal',
  components: { ProductServiceText, ProductCredit, DefLink, DefSlideModal },
  props: ['result'],
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapState({
      isPairSelected: ({ product }) => product?.data?.isPairSelected,
      product: ({ product }) => product?.data?.product,
    }),
    title() {
      return this.result.items.find((el) => el.CODE === 'PRIVATBANK')?.payData.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-credit-modal {
  margin-left: auto;
  //&__link {
  //display: inline-flex;
  //align-items: center;
  //cursor: pointer;
  //  &_disabled {
  //    pointer-events: none;
  //    opacity: 0.4;
  //    cursor: not-allowed;
  //  }
  //}
  //&__icon {
  //  width: 18px;
  //  height: 18px;
  //  margin-right: 6px;
  //  fill: var(--background-black);
  //}
  :deep(.product-credit) {
    border-bottom: 1px solid #dfdfdf;
    margin-bottom: 24px;
  }
}
</style>
